export const INVENTORY_CARD_HEIGHT = 58;
